import apiFetch from '../apiFetch'

export default function ({idAnalisisExtraccion}) {
  return apiFetch({
    endPoint: `Analisis/imprimirMiniEtiqueta?idAnalisis=${idAnalisisExtraccion}`,
    method: 'GET', body: null, token: null
  })
}